var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-aspects-settings"},[_c('page-subtitle',[_vm._v(_vm._s(_vm.$t('pageSettings.aspects')))]),_c('check-box',_vm._g({attrs:{"hide-details":"","input-value":_vm.value}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.$t('pageSettings.showAspects'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }